module.exports = __webpack_public_path__ + "static/img/shcszwy_1.3611f6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customer/shcszwy_1.png
// module id = YBXW
// module chunks = 15